import React from "react";
import Row from "olive-react-myoneui/lib/Row";
import Col from "olive-react-myoneui/lib/Col";
import Card from "olive-react-myoneui/lib/Card";
import EventActivitySlot from "./EventActivitySlot";
import { useSelector } from 'react-redux';
import { imageSrc } from "../../../../helpers/url_helper";
import { format, formatISO, subMinutes, addMinutes, parseISO } from "date-fns";

function EventSessions({ className, eventThumbnail, eventActivities, sessionDate, isSessionExpired, sessionLocation, eventStartDateTime, eventEndDateTime }) {
  const paths = useSelector((state) => state.user.paths);
  const configData = useSelector((state) => state.config);
  const defaultImg = paths?.default_event;
  
  const section  = eventActivities.filter((activity) => activity.ea_activity_type === 'session').length ?? 0; 
  const activity = eventActivities.filter((activity) => activity.ea_activity_type !== 'session').length ?? 0; 

  const dateToISO = (date, time) => {
    if (date == '' && date == null) return null
    const datePart = date.split("T")[0];
    return `${datePart}T${time}Z`;
  }

  const addSubtractMinsToISODate = (isoDate, minutes, type = 'add') => {
    const parsedDate  = parseISO(isoDate);
    const updatedDate = (type === 'add') ? addMinutes(parsedDate, minutes) : subMinutes(parsedDate, minutes);
    return formatISO(updatedDate);
  };

  const isoDateToFormat = (isoDate, formatType = false) => {
    if (formatType) {
      return format(parseISO(isoDate), formatType);
    }
    return new Date(parseISO(isoDate));
  }
 
  const restrictionFlaggedActivity = (isFlagged = '0', activity) => {
    
    if (isFlagged === '0') return false;
    const eventStartDate = eventStartDateTime !== '' ? eventStartDateTime : null;
    const eventEndDate   = eventEndDateTime   !== '' ? eventEndDateTime : null;
    if (eventStartDate === null) {
      return null
    }
    let result = { 
      restrictionLabel : 'Available on ',
      restrictionDate  : '',
      isStartBtnEnable : ''
    };
    /** 
        1 : Based on date and time
        2 : Based on event start date and time
        3 : Based on n minutes before event start date and time
        4 : Based on n minutes after event start date and time
        5 : Based on event end date and time
        6 : Based on n minutes before event end date and time
        7 : Based on n minutes after event end date and time
    **/
    
    let updateStartDate, updateEndDate;           
    switch (activity?.ea_restriction_type) {
      case '7':
          updateEndDate           = addSubtractMinsToISODate(eventEndDate, activity?.ea_restriction_minutes, 'add');
          result.restrictionDate  = isoDateToFormat(updateEndDate, 'yyyy-MM-d HH:mm:ss') ?? '';
          result.isStartBtnEnable = new Date(parseISO(updateStartDate)) <= new Date();
        break;

      case '6':
          updateEndDate           = addSubtractMinsToISODate(eventEndDate, activity?.ea_restriction_minutes, 'subtract');
          result.restrictionDate  = isoDateToFormat(updateEndDate, 'yyyy-MM-d HH:mm:ss') ?? '';
          result.isStartBtnEnable = new Date(parseISO(updateEndDate)) <= new Date();
        break;

      case '5':
          result.restrictionDate  = isoDateToFormat(eventEndDate, 'yyyy-MM-d HH:mm:ss') ?? '';
          result.isStartBtnEnable = new Date(parseISO(eventEndDate)) <= new Date();
        break;

      case '4':
          updateStartDate         = addSubtractMinsToISODate(eventStartDate, activity?.ea_restriction_minutes, 'add');
          result.restrictionDate  = isoDateToFormat(updateStartDate, 'yyyy-MM-d HH:mm:ss') ?? '';
          result.isStartBtnEnable = new Date(parseISO(updateStartDate)) <= new Date();
        break;

      case '3':
          updateStartDate         = addSubtractMinsToISODate(eventStartDate, activity?.ea_restriction_minutes, 'subtract');
          result.restrictionDate  = isoDateToFormat(updateStartDate, 'yyyy-MM-d HH:mm:ss') ?? '';
          result.isStartBtnEnable = new Date(parseISO(updateStartDate)) <= new Date();
        break;

      case '2':
          result.restrictionDate  = isoDateToFormat(eventStartDate, 'yyyy-MM-d HH:mm:ss') ?? '';
          result.isStartBtnEnable = new Date(parseISO(eventStartDate)) <= new Date();
        break;
    
      case '1':
          const restrictionDate   = dateToISO(activity?.ea_restriction_startdate, activity?.ea_restriction_starttime);
          result.restrictionDate  = isoDateToFormat(restrictionDate, 'yyyy-MM-d HH:mm:ss') ?? '';
          result.isStartBtnEnable = new Date(restrictionDate) <= new Date();
        break;
      
      default:
          result.restrictionDate  = '';
          result.isStartBtnEnable = false;
        break;
    }
    return result;
  }
  
  const sessionsData = [
    {
      sectionTitle: `${section} Section, ${activity} Activity`,
      activities: eventActivities && eventActivities.map((item, index) => ({
        thumbnailEvent: item?.ea_activity_type === 'session' 
                          ? (eventThumbnail && eventThumbnail.trim() !== ''
                          ? imageSrc('event', eventThumbnail, paths)
                          : paths.default_event) : item?.ea_activity_type === 'Course' 
                          ? imageSrc('course', item?.activity_detail.image, paths) : 
                          imageSrc('bundle', item?.activity_detail.image, paths),
        title: item?.activity_detail ? item?.activity_detail?.title : item?.ea_title,
        eventDates: item?.ea_session_start_date && item?.ea_session_end_date ? item?.ea_session_start_date + ' - ' + item?.ea_session_end_date : '',
        lectureCount: item?.ea_activity_type === 'Course' ?  item?.activity_detail?.lecture_count : 0,
        status: item?.activity_detail !== null && item?.activity_detail?.subscription && item?.activity_detail?.subscription?.status ? item?.activity_detail?.subscription.status : 'start',
        link: (item?.ea_activity_type === 'Course' && item?.activity_detail !== null && item?.activity_detail !== '') ? `/student-dashboard/courses/detail/${item?.activity_detail?.slug}` : 
              (item?.ea_activity_type === 'Bundle' && item?.activity_detail !== null && item?.activity_detail !== '') ? `/student-dashboard/bundles/${item?.activity_detail?.slug}` :
              (item?.ea_session_delivery_type === 'online' && item?.live_classes !== null && item?.live_classes !== '') ? item.live_classes.lc_session_link+'?user_token='+configData.access_token+'&auto_redirect=true' : '',
        countCourses: item?.ea_activity_type === 'Bundle' && item?.activity_detail?.courses !== '' && item.activity_detail?.courses !== null ? JSON.parse(item.activity_detail?.courses).length : 0,
        countEvents: item?.ea_activity_type === 'Bundle' && item?.activity_detail?.training_events !== '' && item.activity_detail?.training_events !== null ? JSON.parse(item.activity_detail?.training_events).length : 0,
        countTrainingCourses: item?.ea_activity_type === 'Bundle' && item?.activity_detail?.training_courses !== '' && item?.activity_detail?.training_courses !== null ? JSON.parse(item.activity_detail?.training_courses).length : 0,
        type: item?.ea_activity_type ?? '',
        venue: item?.ea_session_delivery_type === 'offline' ? item?.ea_venue_name + ', ' + item?.ea_session_venue_room : '',
        isOnline: item?.ea_session_delivery_type === 'online' ? true : false,
        platform: (item?.ea_session_delivery_type === 'online') ? item?.ea_venue_name  : '',
        isRestrictionFlagged: item?.ea_restriction_flag === '1' ? true : false,
        restrictionActivity: restrictionFlaggedActivity(item?.ea_restriction_flag, item),
        isAttended: item?.ea_activity_type === 'session' &&  item?.ll_attended &&  item?.ll_attended == 1 ? true : false,
      }))
    }
  ];

  return (
    <div className={`${className || ""}`}>
      <Row className="align-items-center">
        <Col lg={12}>
          <div className="bundle-courses-events p-0">
            <h4 className="fw-bold">Sessions</h4>
          </div>
        </Col>
        <Col lg={12}>
          {/* Iterate over each session data */}
          {sessionsData.map((session, index) => (
            <Card className="border-0" key={index}>
              <Card.Body className="p-0">
                <h5 className="text-dark"><strong>{session.sectionTitle}</strong></h5>
                <Row>
                  {/* Iterate over each activity in the current session */}
                  {session.activities.map((activity, activityIndex) => (
                    <Col lg={12} className="mb-3" key={activityIndex}>
                      <EventActivitySlot 
                        thumbnailEvent={activity.thumbnailEvent}
                        title={activity.title}
                        lectureCount={activity.lectureCount}
                        status={activity.status}
                        venue={activity.venue}
                        eventDates={activity.eventDates}
                        eventTimeSlot={activity.eventTimeSlot}
                        type={activity.type}
                        link={activity.link}
                        countCourses={activity.countCourses}
                        countEvents={activity.countEvents}
                        countTrainingCourses={activity.countTrainingCourses}
                        sessionDate={sessionDate}
                        isSessionExpired={isSessionExpired}
                        sessionLocation={sessionLocation}
                        isOnline={activity.isOnline}
                        platform={activity.platform}
                        defaultImg={defaultImg}
                        isRestrictionFlagged={activity.isRestrictionFlagged}
                        restrictionActivity={activity.restrictionActivity}
                        isAttended={activity.isAttended}
                      />
                    </Col>
                  ))}
                </Row>
              </Card.Body>
            </Card>
          ))}
        </Col>
      </Row>
    </div>
  );
}

export default EventSessions;
